export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50 text-xl"></i>
                </div>
                <span className="text-lg font-bold font-heading whitespace-nowrap">
                  被窝影院
                </span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                被窝影院官网提供高清电影电视剧免费在线观看，最新地址首页直达，海量资源每日更新，不卡顿不缓冲，安全便捷的观影平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading text-background-50">快速导航</h4>
              <ul className="flex flex-col gap-2">
                <li><a href="#hero" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a></li>
                <li><a href="#features" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">平台优势</a></li>
                <li><a href="#media" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精彩推荐</a></li>
                <li><a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选合集</a></li>
                <li><a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading text-background-50">影视分类</h4>
              <ul className="flex flex-col gap-2">
                <li><a href="#media" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门电影</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播排行</a></li>
                <li><a href="#updates" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新上架</a></li>
                <li><a href="#index" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">影视索引</a></li>
                <li><a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选合集</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading text-background-50">合作伙伴</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                更多合作站点即将上线，敬请期待。
              </p>
              <div className="mt-4 flex items-center gap-3">
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-mail-line text-background-50 text-sm"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                  <i className="ri-telegram-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; 2026 被窝影院官网. 仅供学习交流使用.
              </p>
              <div className="flex items-center gap-6">
                <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
                <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}